import { SignUpViewChanger } from '../util/view-changer/index.js'
import { PageView } from './PageView.js'
import { CompanyInfoLayout } from '../components/layout/CompanyInfoLayout.js'
import { Header } from '../components/Header.js'

export class InvitationCompanyView extends PageView {
    renderLayout() {
        const {
            mainText = '',
            subText = '',
            companyName = '',
            employeeList = '',
        } = this.$props
        this.$props.CompanyInfoLayOut = new CompanyInfoLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            companyName,
            employeeList,
            nextButton:{
                id : "joinCompanyBtn",
                text: this.getNextButtonText(),
                nextPageFunc: this.nextPage.bind(this),
            },
        })
    }

    renderComponents() {
        if (!this.$props.CompanyInfoLayOut) {
            return
        }

        new Header(this.$props.CompanyInfoLayOut.getHeaderLayer(), {
            isShowLoginBtn : false,
            isShowPrevBtn : true,
        })
    }

    getSectionId() {
        return `invitationCompanySection`
    }

    getNextButtonText() {
        return `${i18next.t(common.requestedToJoin)}`
    }

    nextPage() {
        SignUpViewChanger.loadInvitationEmail()
    }
}